import { observable } from "mobx";
import TarefaService from "../../../services/TarefaService";
import SolicitacaoService from "../../../services/SolicitacaoService";
import EmpregadoService from "../../../services/EmpregadoService";
import { getByAtribute, stringToArray } from "../../../utils/formatar";
import moment from "moment/moment";
import {toast} from "react-toastify";

//RHFPP-612 - Atualizar Gestor Solicitante
export default class AtualizacaoGestorSolicitanteStore {
    @observable loading;
    @observable solicitacoes;
    @observable itemSelecionado;
    @observable gestorSolicitanteFiltro;
    @observable novoGestorSolicitanteFiltro;


    constructor(modalStore) {
        this.modalStore = modalStore;
        this.loading = false;
        this.resetItemSelecionado();
        this.empregadoService = new EmpregadoService();
        this.solicitacaoService = new SolicitacaoService();
        this.tarefaService = new TarefaService();
        this.solicitacoes = [];

        this.filtrarGestorSolicitante = _.debounce(this._filtrarGestorSolicitante, 1000);
    }

    resetItemSelecionado() {
        this.itemSelecionado = {
            idSolicitacao: 0,
            centroCusto: "",
            listaSolicitacaoEtt: null
        };
    }

    carregarLista() {
        this.solicitacoes = [];
        this.loading = true;
        if (this.gestorSolicitanteFiltro && this.gestorSolicitanteFiltro.matricula.length > 1) {
            this.solicitacaoService.carregarSolicitacoesGestorSolicitante(this.gestorSolicitanteFiltro.matricula).then(resultado => {
                if (resultado.status == 200) {
                    this.solicitacoes = [...resultado.data];
                    this.loading = false;
                }
            }).catch(error => {
                this.loading = false;
                console.log("ERROR -------->" + JSON.stringify(error));
            });
        }
        this.loading = false;
    }

    setLista(value) {
        /*console.log("mudando ---------->" + JSON.stringify(value));*/
    }

    preencherModal(row) {
        if (row) {
            this.itemSelecionado = Object.assign({}, row);
            if (row.idSolicitacao) {
                //this.setMomentDataInicio(moment(row.dataInicio));
            }
        } else {
            this.resetitemSelecionado();
        }
    }

    editar() {

        var request = {
            matriculaGestorDe: this.gestorSolicitanteFiltro.matricula,
            matriculaGestorPara: this.novoGestorSolicitanteFiltro.matricula,
            solicitacaoIds: [this.itemSelecionado.idSolicitacao]
        }

        return this.solicitacaoService.atualizarGestorSolicitacao(request).then(response =>  {
            if(response.status == 204){
                toast.success(`Solicitação ${this.itemSelecionado.idSolicitacao} atualizada com sucesso.`);
                this.resetItemSelecionado();
                this.carregarLista();
            }
        });
    }

    setgestorSolicitanteFiltro(value, options) {
        if (value.length > 0) {
            this.gestorSolicitanteFiltro = options[0];
        }
        else {
            this.gestorSolicitanteFiltro = null;
        }
    }
    setNovoGestorSolicitanteFiltro(value, options) {
        if (value.length > 0) {
            this.novoGestorSolicitanteFiltro = options[0];
        }
        else {
            this.novoGestorSolicitanteFiltro = null;
        }
    }

    _filtrarGestorSolicitante(input, callback, soAtivos) {
        let result = [];
        if (input && input.length > 1) {
            if (!soAtivos) {
                // pesquisa gestores por matricula, incluindo os desligados
                this.empregadoService.getGestoresSolicitantesPorMatricula(input).then(response => {
                    callback(null, {
                        options: response.map(gestorSolicitante => {
                            if (gestorSolicitante) {
                                return gestorSolicitante;
                            }
                        }),
                        complete: false
                    });
                }).catch(error => {
                    callback(null, {
                        options: result,
                        complete: false
                    });
                });
            } else {
                this.empregadoService.getByCPFOrMatricula(input).then(response => {
                    callback(null, {
                        options: response.map(gestorSolicitante => {
                            if (gestorSolicitante) {
                                return gestorSolicitante;
                            }
                        }),
                        complete: false
                    });
                }).catch(error => {
                    callback(null, {
                        options: result,
                        complete: false
                    });
                });

            }
        } else {
            callback(null, {
                options: [],
                complete: false
            });
        }
    }

}